import axios from "axios";

/*
|--------------------------------------------------------------------------
| URL de la API
|--------------------------------------------------------------------------
|
| Usa VUE_APP_API_URL cuando está definida.
| Si falta, usa localhost durante desarrollo y Sistemik en producción.
|
*/
const urlLocal = "http://localhost:8000/api";
const urlProduccion =
  "https://poleapp.site/back/public/api";

export const urlBase =
  process.env.VUE_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? urlProduccion
    : urlLocal);

const Api = (configuracion = {}) => {
  const {
    tokenKey = "token",
    redirectOnUnauthorized = true,
  } = configuracion;

  const token = localStorage.getItem(tokenKey);

  const headers = {
    Accept: "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const api = axios.create({
    baseURL: urlBase,
    headers,
    timeout: 30000,
  });

  api.interceptors.response.use(
    (response) => response,

    (error) => {
      const status = error.response
        ? error.response.status
        : null;

      if (status === 401) {
        localStorage.removeItem(tokenKey);

        if (redirectOnUnauthorized) {
          window.location.href = "/";
        }
      }

      if (
        status === 403 &&
        redirectOnUnauthorized
      ) {
        window.location.href =
          "/no-autorizado";
      }

      return Promise.reject(error);
    }
  );

  return api;
};

export default Api;